/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import Empty from "../../../Helpers/Empty/Empty";
import TableRow from "../../../Helpers/Table/TableRow";
import TableActions2 from "../../../Helpers/Table/TableActions2";
import { popupcontext } from "../../../../context/Popupscontext";
import { VehiclePopup } from "../../../Vehicles/VehiclePopUp/VehiclePopUp";
import RequestPopup from "../Popup/RequestPopup";

export default function MaintenanceRequestsTableBody({ data }) {
  const { currentVehicleId, showDetails } = useContext(popupcontext);
  const [showId, setShowId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [editId, setEditId] = useState("");

  const onClose = () => {
    setDeleteId("");
    setShowId("");
    setEditId("");
  };

  const handleDisplayClick = (vehicleId) => {
    if (vehicleId) showDetails("vehicles", vehicleId);
  };
  console.log("id", currentVehicleId);

  return (
    <>
      {data?.length > 0 ? (
        data.map((i) => {
          return (
            <div key={i.id} className="table-row">
              <TableRow value={i.code} />
              <TableRow value={i.name} />
              <TableRow
                value={i.vehicle}
                style="table-element-code ps-0 table-cell-hover"
                onClick={() => handleDisplayClick(i.vehicle)}
              />
              <TableRow value={i.intervals} />
              <TableRow value={i.description} valuestyle={"truncate-2-lines"} />
              <TableActions2 setEditId={setEditId} data={i} button2="Edit" />
            </div>
          );
        })
      ) : (
        <Empty
          title="No requests found"
          subtitle="Create your first maintenance request now!"
        />
      )}
      {currentVehicleId && <VehiclePopup vehicleId={currentVehicleId} />}
      {editId && (
        <RequestPopup id={editId.id} onClose={onClose} title={editId.id} />
      )}
    </>
  );
}
